import React, { useContext } from 'react';
import Navbar from '../components/Navbar';
import { Button } from '../components/ui/button';
import { Link } from 'react-router-dom';
import { AuthContext } from '../App';

export default function HomePage() {
  const { user } = useContext(AuthContext);

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Navbar />

      <div className="pt-20 p-6 max-w-7xl mx-auto flex-1 w-full">
        {/* Hero Section */}
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-4">
            Benvenuti in BASE
          </h1>
          <p className="text-gray-600 mb-6">
            Un ambizioso ecosistema di eccellenza in continua crescita
          </p>
          <div className="flex flex-wrap gap-3">
            <Link to="/regolamento">
              <Button className="bg-black text-white hover:bg-gray-800">
                {user ? 'Regolamento' : 'Candidati ora'}
              </Button>
            </Link>
            {!user && (
              <Link to="/login">
                <Button variant="outline">
                  Area riservata
                </Button>
              </Link>
            )}
          </div>
        </div>

        <div className="mb-8 mt-12">
          <p className="text-gray-700 leading-relaxed whitespace-pre-wrap">
            <section>
              <p>
                In Base, ogni connessione si trasforma in un’opportunità straordinaria.
                La nostra ambizione è quella di offrire un ambiente di eccellenza, che superi
                i confini geografici e favorisca l’incontro di menti aperte, all’interno di una
                comunità in continua crescita.
              </p>
            </section>

            <section>
              <p>
                Base è un vero e proprio ecosistema culturale. Ha il suo centro a Roma,
                mentre il suo raggio di azione è globale: grazie ai suoi soci, crea e sviluppa
                connessioni in grado di generare valore professionale e impatto sociale.
              </p>
            </section>

            <section>
              <p>
                Il Codice Etico guida ogni interazione: integrità, rispetto, collaborazione
                e responsabilità sono i pilastri che sostengono ogni azione dei membri di Base.
              </p>
            </section>

            <section>
              <p>
                La missione è chiara: favorire relazioni di qualità tra professionisti.
                I partecipanti a Base sono selezionati secondo criteri di competenza,
                esperienza e motivazione.
              </p>
            </section>
          </p>
        </div>

      </div>

      {/* Footer */}
      <footer className="bg-white border-t border-gray-200 py-8 px-4 mt-auto">
        <div className="container mx-auto text-center text-gray-600">
          <p>© {new Date().getFullYear()} BASE. Tutti i diritti riservati.</p>
        </div>
      </footer>
    </div>
  );
}
